// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var clearIcon = "Search-module--clearIcon--4cee4";
export var closeButton = "Search-module--closeButton--8cdf2";
export var dialog = "Search-module--dialog--e9bc5";
export var emphasis = "Search-module--emphasis--8d464";
export var green = "#57d33b";
export var greenLink = "Search-module--green-link--295a4";
export var grey = "var(--tone-mid)";
export var hasQuery = "Search-module--hasQuery--c6aa8";
export var modal = "Search-module--modal--364d6";
export var notchGap = "32px";
export var orange = "#f8662b";
export var red = "#ff2741";
export var scrollArea = "Search-module--scrollArea--e733d";
export var scrollThumb = "Search-module--scrollThumb--40b90";
export var searchBox = "Search-module--searchBox--e2fb5";
export var searchInput = "Search-module--searchInput--f59c2";
export var searchInputContainer = "Search-module--searchInputContainer--bb174";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";